import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react'

import setCommonHeaders from '@/src/utils/rtkQuery/setCommonHeaders'
import { BffAccountUserResponse } from '@/src/utils/profile/transformProfileResponse'

export interface GetAccountProfileParams {
    travellersRequired?: boolean
    docRequired?: boolean
    fetchControl?: 'MAIN' | 'ALL'
}

export interface UpdateProfileRequest {
    personal_data: {
        title: string
        first_name: string
        last_name: string
        gender: string
        date_of_birth: string | null
    }
    contact_data: {
        emails: Array<{ email_id: string }>
        addresses: Array<{
            street_address?: string
            city?: string
            state?: string
            pincode?: string
            country?: string
        }>
        phone_numbers: Array<{
            category: string
            phone_number_value: string
            country_code: string
        }>
        requestOtp: null
    }
    screen_name: string
}

const baseQuery = fetchBaseQuery({
    baseUrl: '',
    credentials: 'include',
    prepareHeaders: headers => {
        const defaultHeaders = setCommonHeaders(headers)
        defaultHeaders.set('X-CT-SOURCETYPE', 'web')
        defaultHeaders.set('link-switch', 'ON')
        return defaultHeaders
    }
})

export const profileApi = createApi({
    reducerPath: 'profileApi',
    baseQuery,
    tagTypes: ['AccountProfile'],
    endpoints: builder => ({
        getAccountProfile: builder.query<BffAccountUserResponse, GetAccountProfileParams | void>({
            query: params => {
                const {
                    travellersRequired = false,
                    docRequired = false,
                    fetchControl = 'ALL'
                } = params || {}

                const searchParams = new URLSearchParams({
                    travellersRequired: String(travellersRequired),
                    docRequired: String(docRequired)
                })

                return {
                    url: `/bff/orbit/v1/external-api/v2/user?${searchParams.toString()}`,
                    method: 'GET',
                    headers: {
                        'fetch-control': fetchControl
                    }
                }
            },
            providesTags: ['AccountProfile']
        }),

        updateContactData: builder.mutation<unknown, UpdateProfileRequest>({
            query: body => ({
                url: '/partial/account/contact-data/update',
                method: 'POST',
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8'
                },
                body: encodeURIComponent(JSON.stringify(body))
            }),
            invalidatesTags: ['AccountProfile']
        })
    })
})

export const {
    useGetAccountProfileQuery,
    useLazyGetAccountProfileQuery,
    useUpdateContactDataMutation
} = profileApi
export default profileApi
